<template>
<el-dialog :visible.sync="dialogVisible" top="0" width="565px" :before-close="closeModal" v-if="!canOperate">
    <AlertExclamation class="d-flex mt-5 mb-3 mx-auto" size="46"/>
    <h3 class="c-ndarkthree bold text-center mb-3">
        Habilitar a antecipação para<br>
        este fornecedor?
    </h3>
    <p class="c-ndarkfour regular text-center">
        Ao habilitar, o fornecedor terá permissão para fazer<br>
        pedidos de antecipação na plataforma.
    </p>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <router-link to="" @click.native="closeModal" class="mr-4 pointer">
            <p class="c-ndarkfour">
                Cancelar
            </p>
        </router-link>
        <Button :color="getPrimaryColor" @click="changeCanOperate(1)">
            Habilitar
        </Button>
    </span>
</el-dialog>
<el-dialog :visible.sync="dialogVisible" top="0" width="565px" :before-close="closeModal" v-else>
    <AlertDelete class="d-flex mt-5 mb-2 mx-auto"/>
    <h3 class="c-ndarkthree bold text-center mb-3">
        Desabilitar a antecipação para<br>
        este fornecedor?
    </h3>
    <p class="c-ndarkfour regular text-center">
        Ao desabilitar, o fornecedor não poderá fazer novos<br>
        pedidos de antecipação na plataforma.
    </p>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <router-link to="" @click.native="closeModal" class="mr-4 pointer">
            <p class="c-ndarkfour">
                Cancelar
            </p>
        </router-link>
        <Button :color="getPrimaryColor" @click="changeCanOperate(0)">
            Desabilitar
        </Button>
    </span>
</el-dialog>
</template>

<script>
import AlertDelete from '@/components/icons/AlertDelete'
import AlertExclamation from '@/components/icons/AlertExclamation'
export default {
    components: {
        AlertDelete,
        AlertExclamation
    },
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
        canOperate: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {}
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        },
        changeCanOperate(boolean) {
            this.$emit('changeCanOperate', boolean)
        }
    },
}
</script>

<style scoped>

</style>